export default __webpack_public_path__ + "static/imgComputer-5c149f70deb0bbf1f722836a4766b102.png";